export const budgetCommonPanel = {
    projectNum: '项目编号',
    projectName: '项目名称',
    unit: '单位',
    count: '数量',
    countMoney: '定价总额',
    unitMoney: '人工单价',
    machineryMoney: '机械单价',
    lossRate: '损耗率',
    rate: '折扣率',
    countPrice: '折扣金额',
    remark: '金额',
    main: '主材',
    note: '施工说明',
    sn: '材料编号',
    materialDetail: '材料明细',
    useUnit: '使用单位',
    materialUse: '材料用量',
    brandName: '品牌',
    standard: '商品规格',
    sellMoney: '销售价',
    description: '备注',
    number: '序号',
    type: '类别',
    location: '位置',
    projectDrawing: '产品图&产品名称',
    produceNum: '产品编码',
    produceCode: '产品型号',
    norms: '规格',
    material: '材质',
    unitPrice: '单价',
    modelSize: '模型尺寸',
    produceSize: '商品尺寸',
    area: '面面积：{area}㎡ 地面周长： {perimeter}m 墙面面积{wallArea}㎡ 项目：{total}总价：',
    downloadList: '下载清单',
    decorateCoast: '装修总价：',
    updateTime: ' 预算清单更新于：{updateDate}',
    message1: '共',
    message2: '项，其中{notList}项未填写价格',
};
